var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManCry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.921,
    height: 78.838,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-21.803)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4b3f4e",
    d: "M50.045 62.997h-.952a18.67 18.67 0 0 0-7.1 11.791 21.5 21.5 0 0 0-.389 4.05h8.441l3.134-7.3Z",
    "data-name": "Path 1242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4b3f4e",
    d: "M73.534 74.788a18.68 18.68 0 0 0-7.1-11.791h-.952v.44l-2.972 8.1 2.972 6.923v.376h8.441a21.6 21.6 0 0 0-.389-4.048",
    "data-name": "Path 1243"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc8763",
    d: "M83.604 2.2a1.85 1.85 0 0 0-1.583-.655A70.3 70.3 0 0 1 55.403.658c-16.336-3.673-37.374 7.958-29.68 36.4l2.1 2.307h59.885l2.822-5.314S94.965 15.833 83.604 2.2",
    "data-name": "Path 1244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cd7859",
    d: "M51.788.102C36.167-1.239 18.587 10.678 25.723 37.054l2.1 2.307h4.759l-2.1-2.307C24.065 13.339 37.631 1.312 51.788.102",
    "data-name": "Path 1245"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceaec",
    d: "M50.045 62.997v15.841h5.126l2.673-1.607 2.512 1.607h5.126V62.997Z",
    "data-name": "Path 1246"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d3340",
    d: "m60.356 78.837-1.089-10.343h-3.006l-1.089 10.343Z",
    "data-name": "Path 1247"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5d5360",
    d: "M60.014 62.606H55.67l-.265 4.437a1.47 1.47 0 0 0 .628 1.294l1.132.787a1.19 1.19 0 0 0 1.353 0l1.132-.787a1.47 1.47 0 0 0 .628-1.294Z",
    "data-name": "Path 1248"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.017,
    cy: 6.017,
    r: 6.017,
    fill: "#fcc1ad",
    "data-name": "Ellipse 93",
    transform: "translate(81.69 33.344)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcdfd6",
    d: "M81.873 17.147a4.14 4.14 0 0 0-4.445-1.468 32.4 32.4 0 0 1-19.665-.526c-13.92-4.809-26.053 1.7-29.169 12.58a29 29 0 0 0-.742 4.48q-.031.56-.032 1.131l-.042-.064q-.036.724-.037 1.457c0 16.3 13.441 29.512 30.022 29.512s30.022-13.213 30.022-29.512a29.05 29.05 0 0 0-5.912-17.59",
    "data-name": "Path 1249"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcc1ad",
    d: "M32.5 34.736a25.8 25.8 0 0 1 .853-7c2.208-7.712 8.947-13.225 17.64-14.073-10.94-1.026-19.8 5-22.4 14.073a24 24 0 0 0-.826 5.612 6.016 6.016 0 0 0 .052 12.032 4.6 4.6 0 0 0 1.8-.336 30.01 30.01 0 0 0 28.145 19.2q1.2 0 2.379-.092A29.723 29.723 0 0 1 32.5 34.736",
    "data-name": "Path 1250"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1128"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4b3f4e",
    d: "M73.037 38.236a1.19 1.19 0 0 1-1.19-1.19v-2.64a1.19 1.19 0 0 1 2.379 0v2.64a1.19 1.19 0 0 1-1.189 1.19",
    "data-name": "Path 1251"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4b3f4e",
    d: "M42.485 38.236a1.19 1.19 0 0 1-1.19-1.19v-2.64a1.19 1.19 0 1 1 2.379 0v2.64a1.19 1.19 0 0 1-1.189 1.19",
    "data-name": "Path 1252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4b3f4e",
    d: "M55.031 42.433a1.19 1.19 0 0 1-.9-1.973 4.88 4.88 0 0 1 7.255 0 1.19 1.19 0 0 1-1.792 1.566 2.5 2.5 0 0 0-3.672 0 1.19 1.19 0 0 1-.891.407",
    "data-name": "Path 1253"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#a8c3da",
    d: "M37.267 46.568a3.365 3.365 0 1 0 6.713 0 6.26 6.26 0 0 0-3.357-5.64 6.26 6.26 0 0 0-3.356 5.64",
    "data-name": "Path 1254"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManCry);
export default __webpack_public_path__ + "static/media/man-cry.178e6bc5fb8f126033a7bb3a7e710f8f.svg";
export { ForwardRef as ReactComponent };